import { useState, useEffect } from 'react';
import { getReplicaSlug, onPathChange } from '../lib/routing';
import { getReplicaConfig, findReplicaEmpresa, findReplicaUnidade } from '../lib/replicas.config';

/**
 * Slug da replica ativa baseado na URL atual. null = modo principal.
 */
export function useReplicaSlug() {
  const [slug, setSlug] = useState(getReplicaSlug);
  useEffect(() => onPathChange(() => setSlug(getReplicaSlug())), []);
  return slug;
}

/**
 * Estado completo da replica atual. Resolve empresa E unidade de negocio
 * (se a config tem unidadeNegocioNome).
 *
 * Retorno:
 *   slug          — string ou null
 *   config        — { label, empresaNome, unidadeNegocioNome } ou null
 *   empresa       — objeto empresa que casa, ou null
 *   empresaId     — empresa.id ou null
 *   unidade       — objeto unidade_negocio que casa (so quando config tem
 *                   unidadeNegocioNome), ou null
 *   unidadeId     — unidade.id ou null
 *   isReplica     — true se URL aponta pra alguma replica
 *   misconfigured — true se URL e replica mas:
 *                     a) empresa nao foi resolvida, OU
 *                     b) config tem unidadeNegocioNome mas unidade nao foi
 *                        resolvida (nome nao bate com nenhuma unidade da
 *                        empresa)
 */
export function useReplica(empresas, unidades) {
  const slug = useReplicaSlug();
  const config = getReplicaConfig(slug);
  const empresa = findReplicaEmpresa(slug, empresas);
  const unidade = empresa ? findReplicaUnidade(slug, empresa, unidades) : undefined;

  const cfgWantsUnidade = !!config?.unidadeNegocioNome;
  const misconfigured = !!slug && (
    !empresa ||
    (cfgWantsUnidade && !unidade)
  );

  return {
    slug,
    config: config || null,
    empresa: empresa || null,
    empresaId: empresa?.id || null,
    unidade: unidade || null,
    unidadeId: unidade?.id || null,
    isReplica: !!slug,
    misconfigured,
  };
}
